<template>
    <CompassModal
        v-model:visible="showModal"
        size="large"
        :title="title"
        class="counter-form"
        @closed="$emit('close-popup')"
    >
        <template #default>
            <div class="dialog__default">
                <div v-if="counterLoaded" class="form counter-customisation">
                    <div class="dialog__default--container">
                        <span class="dialog__default--example gray-60">
                            {{ $l10n.__('Exemple de rendu') }}
                        </span>
                        <span class="dialog__default--preview">{{ preview }}</span>
                    </div>
                    <div class="flex-row">
                        <div class="mr-3 w-1">
                            <label for="root" class="dialog__default--label">
                                {{ $l10n.__('Racine') }}
                            </label>
                            <el-input
                                v-model="counter.root"
                                :class="[{ 'has-error': 'root' in errors }]"
                                maxlength="10"
                            />
                        </div>
                        <div class="mr-3 w-2">
                            <label for="dateformat" class="dialog__default--label">
                                {{ $l10n.__('Date') }}
                            </label>
                            <el-select v-model="counter.dateformat" class="wp-10">
                                <el-option
                                    v-for="format in dateFormats"
                                    :key="format.value"
                                    :label="format.name"
                                    :value="format.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="mr-3 w-1">
                            <label for="identcounter" class="dialog__default--label">
                                {{ $l10n.__('Compteur') }}
                            </label>
                            <el-input
                                v-model="counter.identcounter"
                                :class="[{ 'has-error': 'counter' in errors }]"
                                :maxlength="counter.identcounterzerofill"
                            />
                        </div>
                        <div class="mr-3 w-1">
                            <label for="identcounterzerofill" class="dialog__default--label">
                                {{ $l10n.__('Longueur') }}
                            </label>
                            <el-select
                                v-model="counter.identcounterzerofill"
                                @change="updateLengthCounter"
                            >
                                <el-option
                                    v-for="size in counterWidth"
                                    :key="size"
                                    :label="size"
                                    :value="size"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="mr-3 w-2">
                            <label for="glue" class="dialog__default--label">
                                {{ $l10n.__('Séparateur') }}
                            </label>
                            <el-select v-model="counter.glue" class="wp-10">
                                <el-option
                                    v-for="glue in builtGlues"
                                    :key="glue.value"
                                    :label="glue.name"
                                    :value="glue.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="w-2">
                            <label for="style" class="dialog__default--label">
                                {{ $l10n.__('Ordre') }}
                            </label>
                            <el-select v-model="counter.style">
                                <el-option
                                    v-for="ident in identStyles"
                                    :key="ident.value"
                                    :label="ident.name"
                                    :value="ident.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex-row">
                        <div v-if="'root' in errors" class="error-msg">
                            {{ errors.root }}
                        </div>
                        <div v-if="'counter' in errors" class="error-msg ml-3">
                            {{ errors.counter }}
                        </div>
                    </div>
                </div>
                <div v-else class="loader-container prelative mt-5">
                    <preloader :display="true" />
                </div>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('close-popup')"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    class="ml-3"
                    @click="save()"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import CounterFormMixin from './CounterFormMixin.js';

export default {
    components: {
        Preloader,
    },
    mixins: [CounterFormMixin],
    props: {
        counterId: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        glues: {
            type: Array,
            required: true,
        },
        dateFormats: {
            type: Array,
            required: true,
        },
        identStyles: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
        };
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.counter-form {
    .dialog {
        &__default {
            padding-bottom: 24px;
            font-family: 'Proxima Nova';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;

            &--container {
                display: flex;
                flex-direction: column;
                margin-bottom: 16px;
            }

            &--preview {
                font-size: 17px;
                line-height: 24px;
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}

.counter-customisation {
    .has-error input {
        border-color: $red;
    }
    .error-msg {
        color: $red;
    }
}
</style>
